export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';


export const loginRequest = (userInfo) => {
//    console.log('actions : ', LOGIN_REQUEST);

    return {
        type: LOGIN_REQUEST,
        userInfo,
    }
}

export const loginSuccess = (loginInfo) => {
//    console.log('actions : ', LOGIN_SUCCESS, loginInfo);
    return {
        type: LOGIN_SUCCESS,
        loginInfo,
    }
}

export const loginFailure = (error) => {
//    console.log('actions : ', LOGIN_FAILURE);
    return {
        type: LOGIN_FAILURE,
        error,
    }
}

export const logout = () => {
    return {
        type: LOGOUT_REQUEST,
    }
}